import React from 'react';
import { FadeIn } from './FadeIn';
import { ClockIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-129">
      <FadeIn data-id="element-130">
        <div className="bg-sage text-white rounded-3xl p-8 sm:p-12 shadow-xl relative overflow-hidden" data-id="element-131">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" data-id="element-132"></div>
          <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" data-id="element-133"></div>

          <div className="relative z-10" data-id="element-134">
            <div className="flex justify-center mb-6" data-id="element-135">
              <ClockIcon className="w-12 h-12 text-white/90" data-id="element-136" />
            </div>

            <h2 className="text-3xl sm:text-4xl text-center mb-4" data-id="element-137">
              La Sincronía de Ventanas Biológicas
            </h2>
            <p className="text-center text-white/80 font-medium text-lg mb-8 uppercase tracking-wider text-sm" data-id="element-138">
              Este protocolo no es un "entrenamiento". Es un método de
              precisión.
            </p>

            <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-sm" data-id="element-139">
              <p className="text-lg leading-relaxed text-white/95" data-id="element-140">
                Aprendes a identificar la <strong data-id="element-141">"Puerta del Sueño"</strong>:
                un periodo de 15 minutos donde la melatonina natural de tu bebé
                está en su punto máximo. Si lo acuestas en ese momento exacto
                usando nuestra técnica de transferencia, su cerebro toma el
                control y el sueño ocurre casi en automático.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}